import { orderBy, uniqBy } from 'lodash';

export const getMostRecentCommentUsers = (
  prevCommentsUsers = [],
  updatedCommentsList = [],
) => {
  const updatedCommentUsers = updatedCommentsList.map((comment) => ({
    ...comment.user,
    comment_created_at: comment.created_at,
  }));

  const commentUsers = [...prevCommentsUsers, ...updatedCommentUsers];
  const orderedCommentUsers = orderBy(
    commentUsers,
    ['comment_created_at'],
    'desc',
  );

  return uniqBy(orderedCommentUsers, 'id');
};
